import { z } from "zod/v4";

import { CampaignWithIdSchema } from "../../../../../../dtos/deprecated/campaigns";
import { PluginFindReplaceSchema } from "../findReplaces";

export const PluginCampaignSchema_2023_08_20 = CampaignWithIdSchema.extend({
  campaignId: z.uuid().optional(),
  findReplaces: z.optional(PluginFindReplaceSchema.array()),
});
export type PluginCampaignType_2023_08_20 = z.infer<
  typeof PluginCampaignSchema_2023_08_20
>;
